import fp from 'lodash/fp';

export const parseInt = fp.parseInt(10);

export const toKeyValue = (key, value) =>
  fp.flow(
    fp.keyBy(key),
    fp.mapValues(value)
  );

export const isJsonString = value => {
  try {
    const json = JSON.parse(value);
    return typeof json === 'object';
  } catch (e) {
    return false;
  }
};

export const toBase64Encode = string => btoa(string);
